var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", {}, [
            _c("h4", { staticClass: "mb-0" }, [_vm._v("Начисления")])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("staff-multi-select", {
                        on: { change: _vm.onStaffSelect },
                        model: {
                          value: _vm.selectedStaffs,
                          callback: function($$v) {
                            _vm.selectedStaffs = $$v
                          },
                          expression: "selectedStaffs"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "accrual_staff",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "accrual-staff-list",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          bordered: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.fields,
          "sticky-header": "",
          "head-variant": "light",
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          "foot-clone": true,
          "no-footer-sorting": "",
          "tfoot-class": "thead-light"
        },
        on: { "row-dblclicked": _vm.onRowClicked },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(staff_name)",
            fn: function(row) {
              return [
                _vm._v("\n      " + _vm._s(row.item.staff_name) + "\n      "),
                _c("p", { staticClass: "m-0 p-0 text-secondary text-small" }, [
                  _vm._v(_vm._s(row.item.job_title_name))
                ])
              ]
            }
          },
          {
            key: "cell(amount)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-amount",
                    type: "number",
                    step: "0.5",
                    size: "sm",
                    autocomplete: "off"
                  },
                  model: {
                    value: row.item.amount,
                    callback: function($$v) {
                      _vm.$set(row.item, "amount", _vm._n($$v))
                    },
                    expression: "row.item.amount"
                  }
                })
              ]
            }
          },
          {
            key: "cell(quantity)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-quantity",
                    type: "number",
                    step: "0.5",
                    size: "sm",
                    autocomplete: "off"
                  },
                  model: {
                    value: row.item.quantity,
                    callback: function($$v) {
                      _vm.$set(row.item, "quantity", _vm._n($$v))
                    },
                    expression: "row.item.quantity"
                  }
                })
              ]
            }
          },
          {
            key: "cell(ndfl_amount)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-ndfl-amount",
                    type: "number",
                    step: "0.5",
                    size: "sm",
                    autocomplete: "off"
                  },
                  model: {
                    value: row.item.ndfl_amount,
                    callback: function($$v) {
                      _vm.$set(row.item, "ndfl_amount", _vm._n($$v))
                    },
                    expression: "row.item.ndfl_amount"
                  }
                })
              ]
            }
          },
          {
            key: "cell(insurance_amount)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-insurance-amount",
                    type: "number",
                    step: "0.5",
                    size: "sm",
                    autocomplete: "off"
                  },
                  model: {
                    value: row.item.insurance_amount,
                    callback: function($$v) {
                      _vm.$set(row.item, "insurance_amount", _vm._n($$v))
                    },
                    expression: "row.item.insurance_amount"
                  }
                })
              ]
            }
          },
          {
            key: "cell(pension_before_amount)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-pension-before-amount",
                    type: "number",
                    step: "0.5",
                    size: "sm",
                    autocomplete: "off"
                  },
                  model: {
                    value: row.item.pension_before_amount,
                    callback: function($$v) {
                      _vm.$set(row.item, "pension_before_amount", _vm._n($$v))
                    },
                    expression: "row.item.pension_before_amount"
                  }
                })
              ]
            }
          },
          {
            key: "cell(pension_after_amount)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-pension-after-amount",
                    type: "number",
                    step: "0.5",
                    size: "sm",
                    autocomplete: "off"
                  },
                  model: {
                    value: row.item.pension_after_amount,
                    callback: function($$v) {
                      _vm.$set(row.item, "pension_after_amount", _vm._n($$v))
                    },
                    expression: "row.item.pension_after_amount"
                  }
                })
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "link" },
                    on: {
                      click: function($event) {
                        return _vm.onDelete(row)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { name: "buttons/trash", size: 16 } })
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "foot()",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.price(_vm.calculateTotal(row.field))) +
                    "\n    "
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "b-card-footer",
        { attrs: { id: "footer", "footer-bg-variant": "light" } },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "between", "align-v": "center" } },
            [
              _c("b-col", { staticClass: "mr-auto", attrs: { cols: "auto" } }, [
                _vm._v("\n        Записей: "),
                _c("b", [_vm._v(_vm._s(_vm.totalRows))])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c("b-pagination", {
                        staticClass: "mr-2",
                        attrs: {
                          id: "pagination",
                          pills: "",
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "mr-2",
                        attrs: {
                          id: "per-page-select",
                          options: _vm.pageOptions,
                          size: "sm"
                        },
                        on: { change: _vm.onPerPageChange },
                        model: {
                          value: _vm.perPage,
                          callback: function($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d77b02d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d77b02d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccrualStaff/AccrualStaffList.vue
// module id = null
// module chunks = 